import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-rent-car-details',
    templateUrl: './rent-car-details.component.html',
    styleUrls: ['./rent-car-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentCarDetailsComponent {
  businessLine: CarBusinessLine = CarBusinessLine.RENT;
}
